// src/components/Loader.jsx
import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const SpinnerContainer = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
`;

const Spinner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid ${({ theme }) => theme.backgroundAlt};
  border-top-color: ${({ theme }) => theme.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  margin-top: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: ${({ theme }) => theme.weights.medium};
  color: ${({ theme }) => theme.textLight};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Loader = ({ text = "Loading..." }) => (
  <LoaderWrapper>
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
    <LoadingText>{text}</LoadingText>
  </LoaderWrapper>
);

export default Loader;